import { Injector } from "@angular/core";
import { AutoUploadEntityEnum } from "../../../AutoUploadEntityEnum";
import { ServiceEnum } from "../../../ServiceEnum";
import { BaseNode } from "../../BaseNode";
import { ScientificProductsEntity } from "../../../Data/MedicinalProductData/ScientificProductsEntity";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { DateUtil } from "../../../DateUtil";
import { AbstractFormulationsAutoUploadList } from "./AbstractFormulationsAutoUploadList";
import { AbstractPharmaceuticalProductsFormulationAutoUploadList } from "./AbstractPharmaceuticalProductsFormulationAutoUploadList";
import { environment } from "../../../../../../environments/environment";
import { OnDemandAutoUploadNode } from "../OnDemandAutoUploadNode";

export class AbstractFormulationsAutoUploadEntity extends OnDemandAutoUploadNode {
    useHist: boolean = false;
    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any, useHist: boolean, disableAutoUpload:boolean, cloningNode: boolean) {
        super(injector, 
            labelTemplate, 
            ScientificProductsEntity, 
            AutoUploadEntityEnum.abstractFormulations, 
            ServiceEnum.MedicinalProducts, 
            parent, 
            model, 
            AbstractFormulationsAutoUploadList,
            true, 
            disableAutoUpload,
            cloningNode,
            {});
            this.useHist = useHist;
    }

    override postLoadEntity(model: any): void {

        this.children?.push(new AbstractPharmaceuticalProductsFormulationAutoUploadList(this.ioc!,'Abstract Pharmaceutical Products',model.id, false, false, false));
    }

    public getListItem(): any[] {
        return [this.data.model.scientificname,
        this.data.model.scientificcode,
        this.data.model.scientificstrength,
        this.data.model.name_pharmform,
        this.data.model.ownerhqid,
        this.ioc!.get(LookupGetService).retrieveValueFromCache('substancestypes', this.data.model.is_development),
        this.ioc!.get(LookupGetService).retrieveValueFromCache('pispStatus', this.data.model.status),
        DateUtil.getYesNoDateTimeFormat(this.data.model.stamp_nullif)
        ];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: AbstractFormulationsAutoUploadEntity = new AbstractFormulationsAutoUploadEntity(this.ioc!, this.labelTemplate,newParent, this.data.model, this.useHist,this.isLoaded, true);      
      clonedNode.loadEntity();
      clonedNode.isLoading = false;

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
     clonedNode.cloningNode = false;
     return clonedNode;
    }

    override getOnDemandEntities() {
        let onDemandEntities: any = {};
        if (this.isLoaded) {
          this.children?.forEach((child: any) => {
            onDemandEntities = {...onDemandEntities, ...child.getOnDemandEntities()};
          });
        } 

        return {...this.datasource, ...onDemandEntities};
    }

}